<template>
  <div>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100">
        <v-skeleton-loader
          v-if="loadingAll"
          height="110"
          style="margin: 30px 0;"
          type="list-item-avatar-three-line" />
        <stats-card v-else header-color="blue">
          <template slot="header">
            <div class="card-icon"><v-icon class="material-symbols-outlined">contract</v-icon></div>
            <p class="category">{{ $t('activeContacts.currentPlan') }}</p>
            <h3 class="title">
              <div>
                <animated-number :value="quoteResume.quoteTotal" />
              </div>
            </h3>
            <br />
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100">
        <v-skeleton-loader
          v-if="loadingAll"
          height="110"
          style="margin: 30px 0;"
          type="list-item-avatar-three-line" />
        <stats-card v-else header-color="rose">
          <template slot="header">
            <div class="card-icon"><v-icon class='material-icons-outlined' x-large>contact_page</v-icon></div>
            <p class="category">{{ $t('activeContacts.activeContacts') }}</p>
            <h3 class="title">
              <div class="boxRow">

                <animated-number :value="quoteResume.contactsTotal" />
              </div>
            </h3>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100" id="percent-card">
        <v-skeleton-loader
          v-if="loadingAll"
          height="110"
          style="margin: 30px 0;"
          type="list-item-avatar-three-line" />
        <stats-card v-else header-color="green">
          <template slot="header">
            <div class="card-icon"><v-icon>percent</v-icon></div>
            <p class="category">{{ $t('activeContacts.percentageOfUsage') }}</p>
            <h3 class="title">
              <div class="boxRow">
                <animated-number :value="quoteResume.percentTotal" />
                <p>%</p>
              </div>
            </h3>
            <div class="category">
                <p class="pb-0 mb-0">{{ avaliableContacts }} {{ $t('activeContacts.availableContacts') }}</p>
            </div>
          </template>
        </stats-card>
      </div>
    </div>
    <DataTable
      ref="dataTableActiveContacts"
      :title="$t('activeContacts.activeContacts')"
      :data='quoteResume.contacts'
      :customTotal='(quoteResume && quoteResume.contactsTotal) || 0'
      @pagination='handlePagination'
      @nextPage='changePage("next", $event)'
      @prevPage='changePage("prev", $event)'
      :selectable='false'
      :loading='loadingAll || loadingContacts'
      customHeader
      :buttonHeaders="false"
      :endpoint='"activeContacts"'
      :labels='labels'
      :filter='filter'
      :formatLabelFunction='formatLabels'
      fileName='activeContacts'
      class="datable"
      :enablePDF="false"
      limitPagination
      :currentSortOrder.sync='filter.order'
    >
      <template slot="custom-filter">
        <md-button
          class="margin-left margin-top md-sm md-facebook"
          :disabled="loadingCsv"
          @click="requestCsvFile"
          style="float: right;"
        >
          <template v-if="!loadingCsv">
            <md-icon style="font-size: 24px !important;">table_view</md-icon>
            <md-tooltip md-direction="bottom">
              {{ $t('dataTable.generateSpreadsheet') }}
            </md-tooltip>
          </template>
          <template v-else>
            <v-progress-circular
              size="24"
              width="2"
              color="#fff"
              indeterminate
              style="transition: 0.1s; height: 33px;"
            ></v-progress-circular>
          </template>
        </md-button>
        <v-text-field
          style="float: right; width: 350px; margin-top: 15px; margin-right: 5px;"
          :placeholder="$t('simplifiedEditing.searchLabel')"
          hide-details
          height="46px"
          filled
          dense
          background-color="#F9F9F9"
          :value='searchQuery'
          @input='handleSearch'
        ></v-text-field>
      </template>
      <template slot="cells" slot-scope="{ item }">
        <md-table-cell :md-label='labels[0]'>{{ formatLabels(item, 0) }}</md-table-cell>
        <md-table-cell :md-label='labels[1]'>{{ formatLabels(item, 1) }}</md-table-cell>
        <md-table-cell :md-label='labels[2]'>{{ formatLabels(item, 2) }}</md-table-cell>
        <md-table-cell :md-label='labels[3]'>{{ formatLabels(item, 3) }}</md-table-cell>
        <md-table-cell :md-label='labels[4]'>{{ formatLabels(item, 4) }}</md-table-cell>
        <md-table-cell :md-label='labels[5]'>{{ formatLabels(item, 5) }}</md-table-cell>
        <md-table-cell :md-label='labels[6]'>{{ formatLabels(item, 6) }}</md-table-cell>
        <md-table-cell :md-label='labels[7]'>
          <v-row no-gutters style="gap: 8px; flex-wrap: nowrap;">
            <!-- <v-col cols="auto">
              <v-btn
                x-small
                fab
                depressed
                color="#F19D38"
                disabled
                visible="false"

              >
                <v-icon color="white">campaign</v-icon>
                <md-tooltip md-direction="bottom">{{ $t('activeContacts.linkedCampaigns')  }}</md-tooltip>
              </v-btn>
            </v-col> -->
            <v-col cols="auto">
              <v-btn
                x-small
                fab
                depressed
                color="#f44336"
                :disabled="item.notificationsDelivered !== 0"
                @click='handleDelete(item)'
              >
                <v-icon color="white">delete</v-icon>
                <md-tooltip md-direction="bottom">{{ $t('commonWords.exclude') }}</md-tooltip>
              </v-btn>
            </v-col>
          </v-row>
        </md-table-cell>
      </template>
      <template slot="footer" slot-scope='{ pagination }'>
        <v-row style="justify-content: flex-end;">
          <v-col cols="auto">
            <md-field>
              <label for="pages">
                {{$t('assistantsList.perPage')}}
              </label>
              <md-select v-model="pagination.perPage" name="pages">
                <md-option
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >{{ item }}</md-option>
              </md-select>
            </md-field>
          </v-col>
        </v-row>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue'
import StatsCard from '@/components/Cards/StatsCard.vue'
import AnimatedNumber from '@/components/AnimatedNumber'
import { mapFields } from 'vuex-map-fields'
import { selectedLocale } from '@/plugins/i18n'
import moment from 'moment'
import debounce from 'lodash.debounce'
import Swal from 'sweetalert2'

export default {
  components: {
    StatsCard,
    AnimatedNumber,
    DataTable
  },
  created () {
    this.getQuoteResume(false, this.filter)
  },
  data () {
    return {
      labels: [this.$t('activeContacts.recipient'), this.$t('activeContacts.recipientName'), this.$t('activeContacts.lastSentDate'), this.$t('activeContacts.linkedCampaigns'), this.$t('activeContacts.delivered'), this.$t('activeContacts.read'), this.$t('activeContacts.conversationsStarted'), this.$t('activeContacts.actions')],
      filter: {
        order: 'desc',
        page: 0,
        perPage: 5
      },
      searchQuery: '',
      loadingAll: false,
      loadingContacts: false,
      quoteResume: {
        quoteTotal: 0,
        percentContactsUser: 0,
        percentTotal: 0,
        contactsTotal: 0,
        contacts: [],
        after: null
      },
      navigationStack: {},
      loadingCsv: false
    }
  },
  computed: {
    ...mapFields('reports', ['dateInterval']),
    avaliableContacts () {
      return this.quoteResume.quoteTotal - this.quoteResume.contactsTotal
    }
  },
  watch: {
    'filter.perPage': {
      handler () {
        this.getQuoteResume(true, this.filter)
      }
    },
    'filter.search': {
      handler () {
        this.getQuoteResume(true, this.filter)
      }
    }
  },
  methods: {
    handleSearch: debounce(function (searchText) {
      if (searchText) {
        this.$set(this.filter, 'search', searchText)
        this.searchQuery = searchText
      } else {
        this.$delete(this.filter, 'search')
      }
    }, 300),
    async getQuoteResume (onlyContacts = false, params) {
      if (!onlyContacts) {
        this.loadingAll = true
      } else {
        this.loadingContacts = true
      }
      try {
        const { data } = await this.$axios(`${process.env.VUE_APP_REPORTS_BACKEND}/campaign/quote-resume`, {
          params: {
            ...params
          }
        })
        if (!onlyContacts) {
          this.setQuoteResponseToData(data)
        } else {
          this.quoteResume.after = data.after
          this.quoteResume.contacts = data.contacts
        }
      } catch (e) {
      } finally {
        this.loadingAll = false
        this.loadingContacts = false
      }
    },
    setQuoteResponseToData (response) {
      for (const key in this.quoteResume) {
        this.quoteResume[key] = response[key]
      }
    },
    handleContent (key, response) {
    },
    formatDate (date) {
      return moment(date).locale(selectedLocale).format('L LT')
    },
    formatLabels (item, index) {
      switch (index) {
        case 0:
          return item.contact
        case 1:
          return item.name
        case 2:
          return this.formatDate(item.lastNotification)
        case 3:
          return item.totalCampaign
        case 4:
          return item.notificationsDelivered
        case 5:
          return item.notificationsRead
        case 6:
          return item.notificationsProactive
        default:
          break
      }
    },
    openModal (dialogName, mailing = null) {
      this[dialogName] = true
      if (mailing) {
        this.selectedMailing = mailing
      }
    },
    closeModal (dialogName) {
      this[dialogName] = false
      this.selectedMailing = null
    },
    changePage (type, page) {
      let params = {
        ...this.filter
      }
      let currentPage = page

      if (type === 'next') {
        params.after = this.quoteResume.after.contacts
        this.navigationStack[currentPage] = this.quoteResume.after.contacts
      }
      if (type === 'prev') {
        if (currentPage > 1) {
          params.after = this.navigationStack[currentPage]
          delete this.navigationStack[currentPage]
        } else if (currentPage === 1) {
          this.navigationStack = {}
          params.after = null
        }
      }

      this.getQuoteResume(true, {
        ...params
      })
    },
    async requestCsvFile () {
      this.loadingCsv = true
      try {
        await this.$axios(`${process.env.VUE_APP_REPORTS_BACKEND}/campaign/quote-resume/export`)
        Swal.fire({
          icon: 'success',
          title: this.$t('activeContacts.requestReportSuccess'),
          showConfirmButton: true,
          text: this.$t('activeContacts.timeToReceiveReport')
        })
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: this.$t('activeContacts.requestReportError'),
          showConfirmButton: true
        })
      } finally {
        this.loadingCsv = false
      }
    },
    handlePagination (pagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },
    handleDelete (item) {
      Swal.fire({
        icon: 'warning',
        title: this.$t('managementAccess.confirmDeletUser'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: this.$t('commonWords.no'),
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: this.$t('commonWords.yes'),
        buttonsStyling: false
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.$axios.delete(`${process.env.VUE_APP_BACKEND_BASE_URL}/campaign/contacts/${item.contact}`)
            Swal.fire({
              title: this.$t('managementAccess.userDeleted'),
              type: 'success',
              icon: 'success',
              showConfirmButton: false,
              timer: 2000
            })
            setTimeout(() => {
              this.getQuoteResume(false, this.filter)
            }, 2500)
          } catch (error) {
            this.resetLocalData()
            Swal.fire({
              icon: 'error',
              title: this.$t('managementAccess.userDeletedError')
            })
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  table {
    table-layout: fixed;
    @media screen and (max-width: 900px) {
      table-layout: auto;
    }
  }
}
.v-dialog__content {
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 3.5px;
    background-color: #fff;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 3.5px;
    border: 2px solid #fff;
    background-color: rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
  }
}

#percent-card {
  ::v-deep .md-card-stats div.md-card-actions {
      margin-top: 0 !important;
  }
}
</style>
